module.exports = __webpack_public_path__ + "static/kikis-screen1-3aa69b3191dcb4a927de57f40e060dd2.jpg";